import React from 'react';
import i18next from 'i18next';
import { numberWithSpaces } from '../../../utils';
import {
  CRASH_STATUS_BETTING,
  CRASH_STATUS_ENDED,
  CRASH_STATUS_IN_GAME,
} from '../CrashGame';

class StatusBar extends React.PureComponent {
  render() {
    const { status, bets } = this.props;
    const betIds = Object.keys(bets);
    const hasBets = betIds.length > 0;

    return (
      <div className="crash-status-bar">
        <div>
          {status === CRASH_STATUS_ENDED && (
            <span>{i18next.t('crash.status.ended')}</span>
          )}
          {status === CRASH_STATUS_IN_GAME && (
            <span>{i18next.t('crash.status.in_game')}</span>
          )}
          {status === CRASH_STATUS_BETTING && (
            <span>
              {betIds.length > 0 && (
                <span>
                  <span className="crash-status-bar__players">
                    {betIds.length}
                  </span>{' '}
                  {i18next.t('crash.status.betting')}
                </span>
              )}
              {betIds.length === 0 && (
                <span>{i18next.t('crash.status.no_bets')}</span>
              )}
            </span>
          )}
        </div>
        <div>
          {hasBets && (
            <span>
              <span className="crash-status-bar__sum-label">
                {i18next.t('crash.status.total')}:{' '}
              </span>
              <span className="crash-status-bar__sum">
                {numberWithSpaces(
                  betIds.reduce((sum, id) => sum + +bets[id].sum, 0)
                )}{' '}
                R
              </span>
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default StatusBar;



// WEBPACK FOOTER //
// ./app/components/CrashGame/StatusBar/StatusBar.jsx